(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["independent-banner-slider"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('plush-independent-slider')){
customElements.define('plush-independent-slider',class extends HTMLElement{
connectedCallback(){
this.abort=new AbortController();const signal=this.abort.signal;
this.track=this.querySelector('.pis-track');this.slides=[...this.querySelectorAll('.pis-slide')];this.dots=[...this.querySelectorAll('[data-index]')];this.viewport=this.querySelector('.pis-viewport');this.index=0;this.resizeObserver=new ResizeObserver(()=>this.fitHeight());this.slides.forEach(s=>this.resizeObserver.observe(s));this.fitHeight();this.paused=false;this.hovered=false;this.focused=false;this.editing=false;this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
this.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;if(b.hasAttribute('data-prev'))this.go(this.index-1,true);if(b.hasAttribute('data-next'))this.go(this.index+1,true);if(b.hasAttribute('data-index'))this.go(Number(b.dataset.index),true);if(b.hasAttribute('data-pause')){this.paused=!this.paused;b.setAttribute('aria-pressed',String(this.paused));b.textContent=this.paused?'▶':'Ⅱ';this.schedule();}},{signal});
this.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1),true);}},{signal});
this.addEventListener('pointerenter',()=>{this.hovered=true;this.schedule()},{signal});this.addEventListener('pointerleave',()=>{this.hovered=false;this.schedule()},{signal});
this.addEventListener('focusin',()=>{this.focused=true;this.schedule()},{signal});this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.schedule()})},{signal});
this.addEventListener('touchstart',e=>{this.touch=[e.touches[0].clientX,e.touches[0].clientY]},{passive:true,signal});
this.addEventListener('touchend',e=>{if(!this.touch)return;const dx=e.changedTouches[0].clientX-this.touch[0],dy=e.changedTouches[0].clientY-this.touch[1];if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))this.go(this.index+(dx<0?1:-1),true);this.touch=null},{passive:true,signal});
document.addEventListener('visibilitychange',()=>this.schedule(),{signal});this.reduced.addEventListener('change',()=>this.schedule(),{signal});
document.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i<0)return;this.editing=true;this.go(i,false)},{signal});
document.addEventListener('shopify:block:deselect',e=>{if(this.slides.some(s=>s.dataset.blockId===e.detail.blockId)){this.editing=false;this.schedule()}},{signal});this.schedule();
}
go(i,announce){if(!this.slides.length)return;this.index=(i+this.slides.length)%this.slides.length;this.track.style.transform='translateX(-'+this.index*100+'%)';this.slides.forEach((s,n)=>{s.inert=n!==this.index;s.setAttribute('aria-hidden',String(n!==this.index))});this.dots.forEach((b,n)=>b.setAttribute('aria-current',String(n===this.index)));this.fitHeight();if(announce){const status=this.querySelector('.pis-status');if(status)status.textContent=this.slides[this.index].getAttribute('aria-label')}this.schedule();}
fitHeight(){const slide=this.slides[this.index];if(slide)this.viewport.style.height=slide.getBoundingClientRect().height+'px';}
schedule(){clearTimeout(this.timer);if(this.dataset.autoplay==='true'&&this.slides.length>1&&!this.paused&&!this.hovered&&!this.focused&&!this.editing&&!document.hidden&&!this.reduced.matches)this.timer=setTimeout(()=>this.go(this.index+1,false),Number(this.dataset.interval)||7000);}
disconnectedCallback(){this.resizeObserver?.disconnect();clearTimeout(this.timer);this.abort.abort()}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-view-all"]) return;
  try {
    
(async function(){
const root=document.getElementById('pl-view-all');if(!root||root.dataset.initialized)return;root.dataset.initialized='true';
const menus=JSON.parse(root.querySelector('[data-menus]').textContent),labels=JSON.parse(root.querySelector('[data-labels]').textContent),params=new URLSearchParams(location.search);
let category=(menus[params.get('menu')]||[]).find(item=>item.handle===params.get('category'));
if(category&&params.get('subcategory'))category=category.items.find(item=>item.handle===params.get('subcategory'));
const status=root.querySelector('[data-status]'),grid=root.querySelector('[data-grid]'),more=root.querySelector('[data-more]'),retry=root.querySelector('[data-retry]'),urls=new Set();
function collect(items){for(const item of items||[]){if(item.items&&item.items.length)collect(item.items);else if(item.url){const url=new URL(item.url,location.origin);if(url.origin===location.origin&&url.pathname.includes('/collections/'))urls.add(url.pathname);}}}
if(!category){status.textContent=labels.empty;return;}
root.querySelector('[data-title]').textContent=category.title+' — '+labels.all;collect(category.items);
class SizeFamilies {
constructor(){this.allProducts=[];this.sizeGroupingEnabled=params.get('category')==='animals';this.sizeGroups=new Map();this.sizeGroupLabels=labels;}
    getSizeInfo(product) {
      const title = product.title || '';
      const matches = [...title.matchAll(/\b(\d+(?:\.\d+)?)\s*-?\s*(?:["\u2033\u201d]|inch(?:es)?\b|in\b\.?)/gi)];
      if (matches.length !== 1 || !product.image) return null;

      const match = matches[0];
      const baseTitle = (title.slice(0, match.index) + title.slice(match.index + match[0].length))
        .replace(/\s+/g, ' ')
        .replace(/^[\s\u2013\u2014-]+|[\s\u2013\u2014-]+$/g, '')
        .trim();
      if (!baseTitle) return null;

      let imagePath;
      try {
        imagePath = new URL(product.image, window.location.origin).pathname;
      } catch {
        return null;
      }

      return {
        size: Number(match[1]),
        label: match[1] + '\u2033',
        baseTitle,
        key: baseTitle.normalize('NFKC').toLowerCase() + '|' + imagePath
      };
    }

    prepareSizeGroups() {
      this.sizeGroups.clear();
      if (!this.sizeGroupingEnabled) return;

      const families = new Map();
      this.allProducts.forEach(product => {
        const sizeInfo = this.getSizeInfo(product);
        if (!sizeInfo) return;
        if (!families.has(sizeInfo.key)) families.set(sizeInfo.key, []);
        families.get(sizeInfo.key).push({ ...product, sizeInfo });
      });

      families.forEach(members => {
        const sizes = new Set(members.map(member => member.sizeInfo.size));
        if (members.length < 2 || sizes.size !== members.length) return;
        members.sort((a, b) => a.sizeInfo.size - b.sizeInfo.size);
        members.forEach(member => this.sizeGroups.set(member.id, members));
      });
    }

    groupSizeProducts(products) {
      if (!this.sizeGroupingEnabled) return products;

      const included = new Set(products.map(product => product.id));
      const seen = new Set();
      const grouped = [];

      products.forEach(product => {
        const members = this.sizeGroups.get(product.id);
        if (!members) {
          grouped.push(product);
          return;
        }
        const key = members[0].sizeInfo.key;
        if (seen.has(key)) return;
        seen.add(key);

        const matchingMembers = members.filter(member => included.has(member.id));
        const representative = matchingMembers.find(member => member.available) || matchingMembers[0];
        grouped.push({ ...representative, sizeProducts: members });
      });

      return grouped;
    }

    escapeSizeText(value) {
      return String(value).replace(/[&<>"']/g, character => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      })[character]);
    }

    renderSizeChoices(product) {
      const otherSizes = (product.sizeProducts || []).filter(member => member.id !== product.id);
      if (!otherSizes.length) return '';

      return '<div class="ai-collection-grid__size-options-pl-view-all">' + otherSizes.map(member => {
        const label = this.sizeGroupLabels.availableSize.replace('[size]', member.sizeInfo.label);
        const showLabel = this.sizeGroupLabels.showSize.replace('[size]', member.sizeInfo.label) + ' \u2014 ' + member.sizeInfo.baseTitle;
        const hideLabel = this.sizeGroupLabels.hideSize.replace('[size]', member.sizeInfo.label) + ' \u2014 ' + member.sizeInfo.baseTitle;
        return '<button type="button" class="ai-collection-grid__size-toggle-pl-view-all" data-size-toggle="' + member.id + '" ' +
          'aria-expanded="false" aria-controls="size-panel-pl-view-all-' + product.id + '-' + member.id + '" ' +
          'aria-label="' + this.escapeSizeText(showLabel) + '" data-show-label="' + this.escapeSizeText(showLabel) + '" data-hide-label="' + this.escapeSizeText(hideLabel) + '">' +
          '<span>' + this.escapeSizeText(label) + '</span><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M5 8l5 5 5-5"></path></svg></button>';
      }).join('') + '</div>';
    }

    renderSizeFamily(product) {
      const otherSizes = (product.sizeProducts || []).filter(member => member.id !== product.id);
      if (!otherSizes.length) return this.renderProductCard(product);

      return '<div class="ai-collection-grid__size-family-pl-view-all" data-size-family="' + product.id + '">' +
        this.renderProductCard(product) + otherSizes.map(member =>
          '<div class="ai-collection-grid__size-panel-pl-view-all" id="size-panel-pl-view-all-' + product.id + '-' + member.id + '" ' +
          'data-size-panel="' + member.id + '" role="region" aria-label="' + this.escapeSizeText(member.title) + '" hidden>' +
          this.renderProductCard(member, true) + '</div>'
        ).join('') + '</div>';
    }

    setSizeChoice(family, alternateId) {
      family.classList.toggle('is-expanded', alternateId !== null);
      family.querySelectorAll('[data-size-toggle]').forEach(button => {
        const expanded = button.dataset.sizeToggle === alternateId;
        button.setAttribute('aria-expanded', String(expanded));
        button.setAttribute('aria-label', expanded ? button.dataset.hideLabel : button.dataset.showLabel);
      });
      family.querySelectorAll('[data-size-panel]').forEach(panel => {
        panel.hidden = panel.dataset.sizePanel !== alternateId;
      });
    }


    renderProductCard(product, isAlternateSize = false) {
      const esc = this.escapeSizeText;
      return '<article class="ai-collection-grid__product-card-pl-view-all" data-product-id="' + product.id + '">' +
      '<a class="pl-union-card-image" href="' + esc(product.url) + '">' +
      (product.image ? '<img src="' + esc(product.image) + '" alt="' + esc(product.title) + '" width="600" height="600" loading="lazy">' : '') + '</a>' +
      '<div class="pl-union-card-info">' +
      (isAlternateSize ? '<div class="ai-collection-grid__size-comparison-header-pl-view-all"><span>' +
      esc(this.sizeGroupLabels.sizeLabel.replace('[size]', product.sizeInfo.label)) +
      '</span><button class="ai-collection-grid__size-close-pl-view-all" type="button" data-size-close="' + product.id + '" aria-label="' +
      esc(this.sizeGroupLabels.hideSize.replace('[size]', product.sizeInfo.label)) +
      '"><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15"></path></svg></button></div>' : '') +
      '<h3><a href="' + esc(product.url) + '">' + esc(product.title) + '</a></h3>' +
      (product.sku ? '<div class="pl-union-card-sku">SKU: ' + esc(product.sku) + '</div>' : '') +
      '<div class="pl-union-card-price">' + esc(product.price) + '</div>' + this.renderSizeChoices(product) + '</div></article>';
    }

}
const families=new SizeFamilies();
let products=[],shown=0;
function showMore(){
const items=products.slice(shown,shown+40);
grid.insertAdjacentHTML('beforeend',items.map(product=>families.renderSizeFamily(product)).join(''));
shown=Math.min(shown+40,products.length);more.hidden=shown>=products.length;
}
grid.addEventListener('click',event=>{
const trigger=event.target.closest('[data-size-toggle]');
const close=event.target.closest('[data-size-close]');
if(trigger){const family=trigger.closest('[data-size-family]');families.setSizeChoice(family,trigger.getAttribute('aria-expanded')==='true'?null:trigger.dataset.sizeToggle);}
if(close){const family=close.closest('[data-size-family]');families.setSizeChoice(family,null);family.querySelector('[data-size-toggle="'+close.dataset.sizeClose+'"]').focus();}
});
grid.addEventListener('keydown',event=>{
const family=event.target.closest('[data-size-family].is-expanded');
if(event.key==='Escape'&&family){const trigger=family.querySelector('[data-size-toggle][aria-expanded="true"]');families.setSizeChoice(family,null);trigger.focus();event.preventDefault();}
});
more.addEventListener('click',showMore);
async function load(){
retry.hidden=true;more.hidden=true;status.textContent=labels.loading;
try{
const unique=new Map();
for(const pathname of urls){
let next=true,page=1;
while(next){
const url=new URL(pathname,location.origin);url.searchParams.set('view','pl-menu-data');url.searchParams.set('page',page++);url.searchParams.set('preview_theme_id','190063968534');
const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw new Error('Collection request failed');
const result=await response.json();if(!Array.isArray(result.products))throw new Error('Invalid collection response');
for(const product of result.products)unique.set(product.id,product);next=result.next===true;
}
}
families.allProducts=Array.from(unique.values());families.prepareSizeGroups();products=families.groupSizeProducts(families.allProducts);shown=0;grid.replaceChildren();showMore();status.textContent=products.length?products.length+' '+labels.count:labels.empty;
}catch(error){status.textContent=labels.error;retry.hidden=false;}
}
retry.addEventListener('click',load);await load();
})();

  } catch(e) { console.error(e); }
})();
})();
